import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { InventoryPokemonsOutput } from "types/web-app";

export const listInventoryPokemons = async (accessToken: string) => {
  try {
    const response = await fetchWithAuth("/inventory-pokemons", accessToken);

    const data =
      (await response.json()) as ServiceResponse<InventoryPokemonsOutput>;

    return data;
  } catch (error) {
    console.error(error);

    throw error;
  }
};
